<template>
    <div class="login-page">
        <div class="wrapper wrapper-full-page">
        <div class="full-page login-page section-image">
            <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
            <div class="full-page-background" v-bind:style="loginBackground()"></div>
        </div>
        </div>
    </div>
    </template>
    <script>
    import { Card, Checkbox, Button } from 'src/components/UIComponents';
    import Loading from 'vue-loading-overlay';
    import SecureLS from 'secure-ls'
    export default {
        components: {
        Card,
        Loading,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button
        },
        methods: {
        cancelForm(){
        /*** 
        * Función que devuelve al formulario de login
        */
            this.$router.push('/login');
        },
        loginBackground(){
            return 'background-image: url('+process.env.VUE_APP_BASE_ROUTE+'img/login_background.jpg)';
        },
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
        getError (fieldName) {
        /*** 
        * Función que permite visualizar los errores en cada campo del input
        */
            return this.errors.first(fieldName)
        },
        validate () {
        /***
        * Función para validar el formulario de edición y creación que se envía
        */
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                // this.$store.dispatch('updateLoggingIn').then(()=>{
                //     this.$router.push('/');
                // });
                this.$router.push('/login');
                }
            })
        }
        },
        data() {
        return {
            isLoading: false
        }
        },
        errorCaptured(err, vm, info){
            this.$router.go('/login');
        },
        beforeCreate(){
            var ruid = new SecureLS({encodingType: 'aes'});
            ruid.set('ruid', {data: this.$route.params.user_id});
            var rtoken = new SecureLS({encodingType: 'aes'});
            rtoken.set('rtoken', {data: this.$route.params.token});
            this.$router.push('/reset');
        },
        beforeDestroy() {
        this.closeMenu();
        }
    }
</script>
<style>
</style>
